import Loadable from '../../components/loadable';

const CancelledBookingsReport = Loadable({
  loader: () => import('../../pages/reports/cancelled_bookings_report/cancelled_bookings_report'),
});

angular.module('gym').value('CancelledBookingsReport', CancelledBookingsReport);

const CancelledBookingsReportFiltersModal = Loadable({
  loader: () =>
    import('../../pages/reports/cancelled_bookings_report/cancelled_bookings_report_filters_modal'),
  type: 'modal',
});

angular
  .module('gym')
  .value('CancelledBookingsReportFiltersModal', CancelledBookingsReportFiltersModal);
